import DataApi from './DataApi';

class SystemSettingsApi extends DataApi {
  constructor() {
    super('system-settings');
  }

  fetchSettings() {
    return this.get('');
  }

  updateSettings(settings) {
    return this.put('', { settings });
  }
}

export default SystemSettingsApi;
